import { ProcessDesignerUIState } from './process-designer.uistate';
import { Injectable, Injector } from '@angular/core';
import { ElementPropertyConfig, PropertyEntity } from '@farris/ide-property-panel';
import { BackwardRuleComponent, BackwardRuleConverter } from '../views/backward-rule/backward-rule.component';
import { EventDefinitionComponent, EventDefinitionConverter } from '../views/event-definition/event-definition.component';
import { VariableSettingComponent, VariableSettingConverter } from '../views/variable-setting/variable-setting.component';
import { IntermediateCatchEventImplPropertyKeys } from '../designer/wf-cell/property-keys/IntermediateCatchEventImplPropertyKeys';
import { WfLocalePipe } from '../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()

export class CatchEventAdapter {
    constructor(
        private uiState: ProcessDesignerUIState,
        private injector: Injector,
        private localPipe: WfLocalePipe
    ) { }
    setProperty(obj: any) {
        this.uiState.propertyData = obj.propertyData;
        this.uiState.propertyConfig = this.setConfig(obj.propertyConfig);
    }

    private setConfig(obj: any[]): ElementPropertyConfig[] {
        const propertyConfig: ElementPropertyConfig[] = [];
        if (obj) {
            obj.forEach((element: ElementPropertyConfig) => {
                this.setEntity(element.properties);
                propertyConfig.push(element);
            });
        }
        return propertyConfig;
    }
    private setEntity(obj: PropertyEntity[]) {
        if (obj && obj.length > 0) {
            obj.forEach((item: PropertyEntity) => {
                switch (item.propertyID) {
                    case IntermediateCatchEventImplPropertyKeys.BackWardRule:
                        item.editor = BackwardRuleComponent;
                        item.converter = new BackwardRuleConverter(this.localPipe);
                        item.editorParams = {
                            nodeType: 'CallActivitySubProcess'
                        };
                        break;
                    case IntermediateCatchEventImplPropertyKeys.EventDefinitions:
                        item.editor = EventDefinitionComponent;
                        item.converter = new EventDefinitionConverter(this.localPipe);
                        break;
                    case IntermediateCatchEventImplPropertyKeys.variableSettings: // 变量设置
                        item.editor = VariableSettingComponent;
                        item.converter = new VariableSettingConverter(this.localPipe);
                        break;
                    default:
                        break;
                }
            });
        }
    }
}
